import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { TenantState } from '../../shared/features/tenant/shared/services/tenant-state.service';

export const tenantClearResolver: ResolveFn<void> = (): void => {
  const tenantState = inject(TenantState);

  tenantState.clearTenant();
};
